module.exports = __webpack_public_path__ + "static/media/internal_env_4_media_11.dd68041e.webp";